export const ORDER_FORM_GOOD_COLORS = Array.from(
  { length: 10 },
  (_, index) => `var(--onyx-color-category-${index + 1})`,
);
